import { render, staticRenderFns } from "./FieldLabel.vue?vue&type=template&id=73ca0a99&"
import script from "./FieldLabel.vue?vue&type=script&lang=js&"
export * from "./FieldLabel.vue?vue&type=script&lang=js&"
import style0 from "./FieldLabel.vue?vue&type=style&index=0&id=73ca0a99&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports